export const environment = {
  production: true,
  razorpayKeyId: 'rzp_live_RAGbnSyb9t0e18' // 👈 Add this line here
};
